/* eslint-disable */
import Roles from '@/auth/roles';
import i18n from '@/lang' // Internationalization
import historyFullStore from './team-manager-history/team-manager-history-full/team-manager-history-full-store';
import historySingleStore from './team-manager-history/team-manager-history-single/team-manager-history-single-store';
import teamManagerModel from './team-manager-model';
import teamManagerPager from './team-manager-pager';
import service from './team-manager-service';
import positionService from '../position/position-service';
import teamService from '../team/team-service';
import teamModel from '@/entities/team/team-model';

export default {
  namespaced: true,

  modules: {
    historyFull: historyFullStore,
    historySingle: historySingleStore
    },

  state: {
    loading: false,
    list: [],
    pager: teamManagerPager.build(),
    model: teamManagerModel.default(),
    options: {},
  },

  getters: {
    loading: state => state.loading,
    list: state => state.list,
    pager: (state) => state.pager,
    model: state => state.model,
    options: state => state.options,
    hasRoleToUpdate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamManagerEditor.id,
        roles.clubManager.id
      ]);
    },
    hasRoleToCreate: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamManagerEditor.id,
        roles.clubManager.id
      ]);
    },
    hasRoleToRead: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamManagerViewer.id,
        roles.teamManagerEditor.id
      ]);
    },
    hasRoleToReadLogs: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.activityViewer.id
      ]);
    },
    hasRoleToDelete: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamManagerEditor.id,
        roles.clubManager.id
      ]);
    },
    isClubManager: (
      state,
      getters,
      rootState,
      rootGetters
    ) => {
      const roles = Roles.values;
      return rootGetters['auth/hasRole']([
        roles.clubManager.id
      ]);
    }
  },

  mutations: {
    LOADING(state, payload) {
      state.loading = !!payload;
    },

    LIST(state, payload) {
      state.list = payload || [];
    },

    MODEL(state, payload) {
      state.model = payload || teamManagerModel.default();
    },

    CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = teamManagerPager.build();
      state.model = teamManagerModel.default();
      state.options = {};
    },

    ADD_OPTIONS(state, payload) {
      state.options = Object.assign({}, state.options, { [payload.key]: payload.options });
    },
  },

  actions: {
    detail({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service
        .find(id).then((model) => {
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
        });
    },

    new({ commit, dispatch, rootGetters  }) {
      const team = rootGetters['entities/team/model']
      var model = {team:  teamModel.forSimple(team), dorsal: "" , picture: {name:"", size:0, url:""} }
      commit('MODEL', model);
    },

    edit({ commit, dispatch }, id) {
      commit('LOADING', true);

      return service
        .find(id).then((model) => {
          if (!model || !model.id) {
            return Promise.reject(new Error('Not found'));
          }

          commit('MODEL', model);
          commit('LOADING', false);
          return Promise.resolve();
        });
    },

    save({ getters, commit, rootGetters, dispatch }) {
      commit('LOADING', true);
      const team = rootGetters['entities/team/model']
      var model = getters.model
      var modelToSave = model
      
      if (team.id !== null) {
        modelToSave = { ...model, team: teamModel.forSimple(team)}
      }

      return  service
          .save(modelToSave, rootGetters['auth/user'])
          .then(() => {
            dispatch(
              'shared/success',
              `${i18n.t('entities.teamManager.singular')} ${i18n.t('notification.savedSuccessfully')}`,
              { root: true }
            );

            commit('LOADING', false);
          });
    },

    destroy({ commit, dispatch, rootGetters }, model) {
      commit('LOADING', true);
      console.log("<---- STORE DESTROY PLAYER");
      
      const team = rootGetters['entities/team/model']
      console.log("<---- STORE MODEL TEAM");
      console.log(team);
      console.log("<---- STORE MODEL PLAYER");
      console.log(model);
      
      var modelToDestroy = model
      if (team.id !== null) {
         modelToDestroy = { ...model, team: team}
      }
        
      return service
        .destroy(modelToDestroy, rootGetters['auth/user'])
        .then(() => {
          dispatch(
            'shared/success',
            `${i18n.t('entities.teamManager.singular')} ${i18n.t('notification.deletedSuccessfully')}`,
            { root: true }
          );
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    list({ commit, dispatch }) {
      commit('LIST', []);
      commit('LOADING', true);

      return service
        .list()
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },

    listByTeamId({ commit, dispatch }, teamId) {
      commit('LIST', []);
      commit('LOADING', true);

      return service
        .listByTeamId(teamId)
        .then((list) => {
          commit('LIST', list);
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },
    
    exportAsPDF({getters, commit, dispatch, rootGetters }) {
      commit('LOADING', true);

      return service
        .exportAsPDF(getters.list)
        .then(() => {
          commit('LOADING', false);
        })
        .catch((error) => {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return Promise.reject(error);
        });
    },
    clear({ commit }) {
      commit('CLEAR');
    },

    loadOptions({ commit, dispatch }) {
      positionService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'positions', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
      teamService.listOptions().then((options) => {
        commit('ADD_OPTIONS', { key: 'teams', options });
      }).catch((error) => {
        dispatch('shared/error', error, { root: true });
        return Promise.reject(error);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/entities/team-manager/team-manager-store.js